// extracted by mini-css-extract-plugin
export default {"root":"matches_constraints-module___root___db988402"};